export const FLEX_CENTER = {
  row: 'flex items-center justify-center',
  column: 'flex flex-col items-center justify-center',
};
